import { render, staticRenderFns } from "./Waybill.vue?vue&type=template&id=1074e78d&scoped=true&"
import script from "./Waybill.vue?vue&type=script&lang=js&"
export * from "./Waybill.vue?vue&type=script&lang=js&"
import style0 from "./Waybill.vue?vue&type=style&index=0&id=1074e78d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1074e78d",
  null
  
)

export default component.exports